<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import PushCampaignDetail from '@/modules/push-campaign/views/PushCampaignDetail.vue'
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const isCreate = computed(() => route.name === 'push-campaign-list-create')

const campaignId = computed(() => {
  const id = route.params.id
  const n = Number(id)
  return Number.isFinite(n) ? n : null
})
</script>

<template>
  <dashboard-layout
    :currentRoute="isCreate ? 'push-campaign/list/create' : 'push-campaign/list'"
    :pageTitle="isCreate ? 'Chiến dịch thông báo đẩy • Tạo mới' : 'Chiến dịch thông báo đẩy • Chi tiết'"
    :tabs="[]"
    :tabsEvent="{}"
  >
    <panel>
      <push-campaign-detail :campaign-id="campaignId" />
    </panel>
  </dashboard-layout>
</template>

<style scoped></style>
